/** HSE location template detection — mirrors backend location_field_map.py */

export const LOCATION_IMPORT_DOMAIN_ID = 'location';

const HSE_HEADER_ALIASES = new Set([
  'global id',
  'iss site id',
  'customer (iss)',
  'building name / description / premisis identifier',
  'building name / description / premises identifier',
  'street number',
  'street address 1 (thoroughfare / road name)',
  'street address 2 (thoroughfare / road name)',
  'city / town',
  'district',
  'region / county / state (us)',
  'postal code / zip code',
  'country name',
  'latitude',
  'longitude',
]);

function normalizeHeader(header: string): string {
  return header.trim().toLowerCase().replace(/\s+/g, ' ');
}

/** True when the CSV uses HSE / business column headers. */
export function isHseLocationFile(columns: string[]): boolean {
  const normalized = columns.map(normalizeHeader);
  return normalized.some((h) => HSE_HEADER_ALIASES.has(h));
}

/**
 * Route HSE uploads to the location validation import path.
 * DB-style exports (site_name, locode, …) keep the selected domain id.
 */
export function resolveImportDomainId(
  selectedDomainId: string | undefined,
  columns: string[],
): string | undefined {
  if (isHseLocationFile(columns)) {
    return LOCATION_IMPORT_DOMAIN_ID;
  }
  return selectedDomainId;
}
